var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { BaseService } from "./baseService";
class SettingService extends BaseService {
    constructor() {
        super(...arguments);
        this.controllerName = "approversettings";
    }
    verifyPassword(password) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.post(`/${this.controllerName}/auth`, {
                password
            });
            return data;
        });
    }
    getStatus() {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.get(`/${this.controllerName}`);
            return data;
        });
    }
    modifyStatus(newValue) {
        return __awaiter(this, void 0, void 0, function* () {
            this.api.defaults.headers = this.getDefaultHeaders();
            const { data } = yield this.api.put(`/${this.controllerName}`, {
                increaseSubadminPermissions: newValue
            });
            return data;
        });
    }
}
export const settingService = new SettingService();
//# sourceMappingURL=settingService.js.map